import { useEffect, useState } from "react";
import { fetchPublicProjects } from "../lib/adminApi";

// Fetches admin-published projects; falls back to demo projects when none exist.
export const useProjects = (fallback = []) => {
  const [items, setItems] = useState(null);
  useEffect(() => {
    let active = true;
    fetchPublicProjects()
      .then(({ data }) => { if (active) setItems(data); })
      .catch(() => { if (active) setItems([]); });
    return () => { active = false; };
  }, []);
  const projects = items && items.length ? items : fallback;
  return { projects, loading: items === null };
};
